import React from "react";
import { IonPage, IonButton } from "@ionic/react";
import { inject, observer } from "mobx-react";
import { Link, RouteComponentProps } from "react-router-dom";

interface IProps extends RouteComponentProps {
  userStore: any;
}

@inject("userStore")
@observer
class LandingEmbed extends React.Component<IProps> {
  get isAuthenticated() {
    const userStore = this.props.userStore;
    if (!userStore || !userStore.currentUser) {
      return false;
    }
    return userStore.currentUser.isAuthenticated;
  }

  renderHeaderCtas() {
    if (!this.isAuthenticated) {
      return (
        <div style={{ display: "flex", gap: 8 }}>
          <Link to="/signin" className="mont M">
            <IonButton className="home-button fw-800" color="medium-light">
              Log In
            </IonButton>
          </Link>
          <a
            href="https://getwaitlist.com/waitlist/24610"
            target="_blank"
            rel="noopener noreferrer"
            className="mont M"
          >
            <IonButton className="home-button fw-800" color="quarternary">
              Join the Waitlist
            </IonButton>
          </a>
        </div>
      );
    }

    return (
      <Link to="/goals" className="mont M">
        <IonButton className="home-button fw-800" color="quarternary">
          Enter App
        </IonButton>
      </Link>
    );
  }

  render() {
    return (
      <IonPage>
        {/* Simple top bar with conditional CTAs matching Home logic */}
        {/* <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 8,
            padding: "8px 12px",
            position: "sticky",
            top: 0,
            zIndex: 10,
            background: "#fff",
            borderBottom: "1px solid rgba(0,0,0,0.06)",
          }}
        >
          {this.renderHeaderCtas()}
        </div> */}
        <iframe
          title="Goalden Hour New Landing"
          src={`${process.env.PUBLIC_URL}/public/home/index.html`}
          style={{
            width: "100%",
            height: "calc(100vh - 49px)",
            border: "none",
            display: "block",
          }}
        />
      </IonPage>
    );
  }
}

export default LandingEmbed;
